import * as React from 'react';
/**
 *
 * Original name: h3
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=33209%3A9703
 *
 */
export const H3Line = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M4.5 11.5H12v-6h1.5V19H12v-6H4.5v6H3V5.5h1.5v6Zm16.675 5.529c0 1.224-1.107 1.971-3.015 1.971-2.142 0-2.951-.738-2.951-2.313v-.108h1.34v.072c0 .846.495 1.188 1.611 1.188 1.08 0 1.611-.351 1.611-.927 0-.612-.422-.783-1.395-.783h-.9v-1.017h.883c.935 0 1.322-.243 1.322-.774 0-.558-.486-.882-1.457-.882-1.08 0-1.611.432-1.62 1.152v.054H15.29v-.081c0-1.449 1.08-2.268 2.96-2.268 1.729 0 2.808.711 2.808 1.863 0 .765-.386 1.179-1.07 1.368.756.189 1.188.63 1.188 1.485Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
